import { api } from './api'
import { authed, type TokenPair } from './auth'
import { isStaging } from './stage'

export interface DesktopLoginRequest { id: string; secret: string; expires_in: number; interval: number }
export interface DesktopLoginInfo { device: string; ip: string; expires_in: number; status: string }
export const desktopLoginApi = {
  start: () => api<DesktopLoginRequest>('/auth/desktop', { method: 'POST' }),
  poll: (r: DesktopLoginRequest, signal: AbortSignal) => api<{ status: string; session: TokenPair | null }>(`/auth/desktop/${r.id}/poll`, { method: 'POST', body: JSON.stringify({ secret: r.secret }), signal }),
  cancel: (r: DesktopLoginRequest) => api<void>(`/auth/desktop/${r.id}/cancel`, { method: 'POST', body: JSON.stringify({ secret: r.secret }) }),
  deny: (id: string) => authed<void>(`/auth/desktop/${id}/deny`, { method: 'POST' }),
  info: (id: string) => authed<DesktopLoginInfo>(`/auth/desktop/${id}`),
  approve: (id: string) => authed<void>(`/auth/desktop/${id}/approve`, { method: 'POST' }),
}
export function desktopLoginFromLocation(): string | null {
  return /^#desktop-login=([a-f0-9]{64})$/.exec(window.location.hash)?.[1] ?? null
}
export function desktopLoginURL(id: string): string {
  const url = new URL('/', window.location.origin)
  url.hash = `desktop-login=${id}`
  return url.href
}
export function desktopOpenURL(): string {
  return isStaging ? 'klichat-dev://open' : 'klichat://open'
}
